import {
    Consciousness,
    NutritionalStatus,
    RespiratoryType,
    HeatType,
    AppointmentDuration,
    ActivityStatus,
    PaymentMethod,
    PetSex,
    PetStatus,
} from '@/shared/types/enums';

const triggerToastEventName = 'trigger-toast';

const BIRTHDAY_FORMAT = 'YYYY-MM-DD';

const CONSTANTS = {
    FAVORITES: [
        {
            id: 1,
            icon: 'pie-chart',
            route: 'Reports',
        },
        {
            id: 2,
            icon: 'calendar',
            route: 'GlobalAppointment',
        },
        {
            id: 3,
            icon: 'shopping-cart',
            route: 'NewVisit',
        }
    ],
    GENDERS: [
        {
            value: 'M',
            label: 'commons.male'
        },
        {
            value: 'F',
            label: 'commons.female'
        },
        {
            value: 'NB',
            label: 'commons.noBinary'
        },
        {
            value: 'PF',
            label: 'commons.omitted'
        },
        {
            value: 'O',
            label: 'commons.other'
        }
    ],
    ROLES: [
        {
            value: 'admin',
            label: 'collaborator.admin'
        },
        {
            value: 'counter',
            label: 'collaborator.counter'
        },
        {
            value: 'veterinary',
            label: 'collaborator.veterinary'
        },
        {
            value: 'external',
            label: 'collaborator.external'
        },
        {
            value: 'auditor',
            label: 'collaborator.auditor'
        }
    ],
    PET_SEX: [
        {
            value: PetSex.Male,
            label: 'commons.male_pet',
        },
        {
            value: PetSex.Female,
            label: 'commons.female_pet',
        }
    ],
    FISCAL_REGIMES: [
        {
            value: '601',
            label: 'commons.regimes.601'
        },
        {
            value: '603',
            label: 'commons.regimes.603'
        },
        {
            value: '605',
            label: 'commons.regimes.605'
        },
        {
            value: '606',
            label: 'commons.regimes.606'
        },
        {
            value: '607',
            label: 'commons.regimes.607'
        },
        {
            value: '608',
            label: 'commons.regimes.608'
        },
        {
            value: '609',
            label: 'commons.regimes.609'
        },
        {
            value: '610',
            label: 'commons.regimes.610'
        },
        {
            value: '611',
            label: 'commons.regimes.611'
        },
        {
            value: '612',
            label: 'commons.regimes.612'
        },
        {
            value: '614',
            label: 'commons.regimes.614'
        },
        {
            value: '615',
            label: 'commons.regimes.615'
        },
        {
            value: '616',
            label: 'commons.regimes.616'
        },
        {
            value: '620',
            label: 'commons.regimes.620'
        },
        {
            value: '621',
            label: 'commons.regimes.621'
        },
        {
            value: '622',
            label: 'commons.regimes.622'
        },
        {
            value: '623',
            label: 'commons.regimes.623'
        },
        {
            value: '624',
            label: 'commons.regimes.624'
        },
        {
            value: '625',
            label: 'commons.regimes.625'
        },
        {
            value: '626',
            label: 'commons.regimes.626'
        },
        {
            value: '628',
            label: 'commons.regimes.628'
        },
        {
            value: '629',
            label: 'commons.regimes.629'
        },
        {
            value: '630',
            label: 'commons.regimes.630'
        },
        {
            value: '631',
            label: 'commons.regimes.631'
        },
    ],
    COUNTRIES: [
        {
            value: 'MX',
            label: 'commons.countries.MX'
        },
        {
            value: 'US',
            label: 'commons.countries.US'
        }
    ],
    UNITS: [
        {
            value: 'bag',
            label: 'products.units.1'
        },
        {
            value: 'box',
            label: 'products.units.2'
        }
    ],
    CATEGORY_TYPES: [
        {
            value: 'product',
            label: 'categories.types.1'
        },
        {
            value: 'package',
            label: 'categories.types.2'
        }
    ],
    OWNER_TABS: [
        {
            icon: 'list',
            route: 'OwnerDashboard',
            type: 'route',
        },
        {
            icon: 'user',
            route: 'OwnerDetails',
            type: 'route',
        },
        {
            icon: 'address-card',
            route: 'OwnerCredential',
            type: 'route',
        },
        {
            icon: 'key',
            route: 'OwnerToken',
            type: 'modal',
        },
        {
            icon: 'shopping-cart',
            route: 'NewVisit',
            type: 'route',
        },
        {
            icon: 'calendar',
            route: 'OwnerAppointment',
            type: 'route',
        },
    ],
    BUSINESS_TABS: [
        {
            prefix: 'far',
            icon: 'building',
            route: 'BusinessDetails',
            type: 'route',
        },
        {
            icon: 'users',
            route: 'ListCollaborators',
            type: 'route',
        },
        {
            icon: 'cube',
            route: 'BusinessInventory',
            type: 'route',
        },
        {
            icon: 'circle-dollar-to-slot',
            route: 'BusinessBalance',
            type: 'route',
        },
        {
            icon: 'rectangle-list',
            route: 'Formats',
            type: 'route',
        },
        {
            icon: 'database',
            route: 'Database',
            type: 'route',
        },
    ],
    PET_STATUS_BG: [
        {
            state: PetStatus.Active,
            bg: 'bg-[#FFFFFF] opacity-80'
        },
        {
            state: PetStatus.Defeated,
            bg: 'bg-[#90D0FF] opacity-80'
        },
        {
            state: PetStatus.Suspended,
            bg: 'bg-[#AAA3A3] opacity-80'
        }
    ],
    PET_KINDS: [
        { value: "dog", label: "pet.kinds.1" },
        { value: "cat", label: "pet.kinds.2" },
        { value: "rodent", label: "pet.kinds.3" },
        { value: "mustelid", label: "pet.kinds.4" },
        { value: "marsupial", label: "pet.kinds.5" },
        { value: "bird", label: "pet.kinds.6" },
        { value: "reptile", label: "pet.kinds.7" },
        { value: "fish", label: "pet.kinds.8" },
        { value: "invertebrate", label: "pet.kinds.9" },
        { value: "lagomorph", label: "pet.kinds.10" },
        { value: "erinaceomorph", label: "pet.kinds.11" },
        { value: "pig", label: "pet.kinds.12" },
        { value: "other", label: "pet.kinds.13" },
    ],
    PET_SUFFERINGS: [
        { value: "DA", label: "sufferings.1" },
        { value: "IBP", label: "sufferings.2" },
        { value: "SD", label: "sufferings.3" },
        { value: "IH", label: "sufferings.4" },
        { value: "OE", label: "sufferings.5" },
        { value: "P", label: "sufferings.6" },
        { value: "M", label: "sufferings.7" },
        { value: "TP", label: "sufferings.8" },
        { value: "A", label: "sufferings.9" },
        { value: "PI", label: "sufferings.10" },
        { value: "G", label: "sufferings.11" },
        { value: "ED", label: "sufferings.12" },
        { value: "OG", label: "sufferings.13" },
        { value: "EII", label: "sufferings.14" },
        { value: "PD", label: "sufferings.15" },
        { value: "FG", label: "sufferings.16" },
        { value: "DGT", label: "sufferings.17" },
        { value: "TI", label: "sufferings.18" },
        { value: "N", label: "sufferings.19" },
        { value: "CT", label: "sufferings.20" },
        { value: "RS", label: "sufferings.21" },
        { value: "EP", label: "sufferings.22" },
        { value: "DP", label: "sufferings.23" },
        { value: "IRC", label: "sufferings.24" },
        { value: "ITU", label: "sufferings.25" },
        { value: "UL", label: "sufferings.26" },
        { value: "FLUTD", label: "sufferings.27" },
        { value: "OU", label: "sufferings.28" },
        { value: "LR", label: "sufferings.29" },
        { value: "DC", label: "sufferings.30" },
        { value: "F", label: "sufferings.31" },
        { value: "OAD", label: "sufferings.32" },
        { value: "RLC", label: "sufferings.33" },
        { value: "MC", label: "sufferings.34" },
        { value: "PC", label: "sufferings.35" },
        { value: "L", label: "sufferings.36" },
        { value: "PF", label: "sufferings.37" },
        { value: "IVF", label: "sufferings.38" },
        { value: "O", label: "sufferings.39" },
        { value: "EP", label: "sufferings.40" },
        { value: "UC", label: "sufferings.41" },
        { value: "C", label: "sufferings.42" },
        { value: "CT", label: "sufferings.43" },
    ],
    PET_ALLERGIES: [
        {
            value: '1',
            label: 'allergies.1'
        },
        {
            value: '2',
            label: 'allergies.2'
        },
        {
            value: '3',
            label: 'allergies.3'
        },
        {
            value: '4',
            label: 'allergies.4'
        },
        {
            value: '5',
            label: 'allergies.5'
        },
        {
            value: '6',
            label: 'allergies.6'
        },
        {
            value: '7',
            label: 'allergies.7'
        },
        {
            value: '8',
            label: 'allergies.8'
        },
        {
            value: '9',
            label: 'allergies.9'
        },
        {
            value: '10',
            label: 'allergies.10'
        }
    ],
    HEAT_TYPES: [
        {
            value: HeatType.Normal,
            label: 'heats.types.1'
        },
        {
            value: HeatType.ElectiveCesarean,
            label: 'heats.types.2'
        },
        {
            value: HeatType.Cesarean,
            label: 'heats.types.3'
        },
    ],
    CONSCIOUSNESS: [
        {
            value: Consciousness.Stupor,
            label: 'ecop.consciousness.1',
        },
        {
            value: Consciousness.Comatose,
            label: 'ecop.consciousness.2',
        }
    ],
    NUTRITIONAL: [
        {
            value: NutritionalStatus.Obese,
            label: 'ecop.nutritional.1',
        }
    ],
    RESPIRATORY_TYPES: [
        {
            value: RespiratoryType.Restricted,
            label: 'ecop.respiratoryRates.1',
        },
        {
            value: RespiratoryType.Obstructed,
            label: 'ecop.respiratoryRates.2',
        },
        {
            value: RespiratoryType.Diverse,
            label: 'ecop.respiratoryRates.3',
        },
        {
            value: RespiratoryType.Percussion,
            label: 'ecop.respiratoryRates.4',
        }
    ],
    APPOINTMENTS_TYPES: [
        {
            value: AppointmentDuration.Day,
            label: 'appointments.durationValues.1',
        },
        {
            value: AppointmentDuration.Week,
            label: 'appointments.durationValues.2',
        },
        {
            value: AppointmentDuration.Month,
            label: 'appointments.durationValues.3',
        },
        {
            value: AppointmentDuration.Year,
            label: 'appointments.durationValues.4',
        },
    ],
    STATUS_TYPES: [
        {
            value: ActivityStatus.Created,
            label: 'dashboard.status.1',
        },
        {
            value: ActivityStatus.InProgress,
            label: 'dashboard.status.2',
        },
        {
            value: ActivityStatus.Cancelled,
            label: 'dashboard.status.3',
        },
        {
            value: ActivityStatus.Processed,
            label: 'dashboard.status.4',
        },
    ],
    PAYMENT_METHOD_TYPES: [
        {
            value: PaymentMethod.CreditCard,
            label: 'visit.methods.1'
        },
        {
            value: PaymentMethod.DebitCard,
            label: 'visit.methods.2'
        },
        {
            value: PaymentMethod.Cash,
            label: 'visit.methods.3'
        },
        {
            value: PaymentMethod.Other,
            label: 'visit.methods.4'
        },
    ],
};

const backgroundColorsPets: Record<PetStatus, string> = {
    [PetStatus.Active]: "pet-active",
    [PetStatus.Defeated]: "pet-defeated",
    [PetStatus.Suspended]: "pet-suspended",
};

const printDefault = {
    orientation: 'portrait',
    unit: 'in',
    format: 'letter',
    font: 'Arial',
    font_size: 12,
    dimensions: {
        width: 595.28,
        height: 841.89,
    },
    margin: {
        top: 1,
        bottom: 1,
        left: 1,
        right: 1
    }
}

export {
    CONSTANTS,
    BIRTHDAY_FORMAT,
    triggerToastEventName,
    printDefault,
    backgroundColorsPets,
}
